<mat-card class="card-style px-6 py-6 pt-3">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Pesquisa endereço</mat-card-title>
    </div>
    <button mat-flat-button class="btn-tg-cancel w-2/12" (click)="close()">
      Cancelar
    </button>
    <button mat-flat-button class="btn-tg w-2/12" (click)="insertAddress()">
      Adicionar
    </button>
  </mat-card-header>

  <div [formGroup]="formMaps" class="pb-4 pt-3 mt-4">
    <div class="flex justify-between gap-4 items-center">
      <!--      <mat-form-field class="input-tg w-3/12" appearance="outline">-->
      <!--        <mat-label>Localização</mat-label>-->
      <!--        <input matInput formControlName="location" />-->
      <!--      </mat-form-field>-->

      <mat-form-field
        class="input-tg w-full no-message-new"
        appearance="outline"
      >
        <input
          type="text"
          matInput
          placeholder="Pesquisa"
          formControlName="location"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onOptionSelected($event)"
        >
          <mat-option
            *ngFor="let option of filteredOptions$ | async"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    @if (loadingGoogle) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <!--    <div class="flex justify-end">-->
    <!--      <button mat-flat-button class="btn-tg w-1/5" (click)="searchGoogle()">-->
    <!--        Pesquisa-->
    <!--      </button>-->
    <!--    </div>-->
  </div>
  <div class="mb-4">
    <mat-divider></mat-divider>
  </div>
  <div [formGroup]="form" class="pb-2 pt-3">
    <!--    <div class="flex justify-start gap-4 items-center">-->
    <!--      <mat-form-field class="input-tg w-3/12" appearance="outline">-->
    <!--        <mat-label>Área Tarrifário</mat-label>-->
    <!--        <mat-select formControlName="tariffArea">-->
    <!--          @for (item of listArea; track item) {-->
    <!--            <mat-option [value]="item.value">{{ item.description }}</mat-option>-->
    <!--          }-->
    <!--        </mat-select>-->
    <!--      </mat-form-field>-->
    <!--    </div>-->
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
    </div>
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>CEP</mat-label>
        <!--        <input-->
        <!--          matInput-->
        <!--          (input)="getAddressByPostalCode()"-->
        <!--          (blur)="getAddressByPostalCode()"-->
        <!--          formControlName="postalCode"-->
        <!--        />-->
        <input matInput formControlName="postalCode" />
      </mat-form-field>

      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>Latitude</mat-label>
        <input matInput formControlName="latitude" />
      </mat-form-field>

      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>Longitude</mat-label>
        <input matInput formControlName="longitude" />
      </mat-form-field>
      <mat-form-field class="input-tg w-6/12" appearance="outline">
        <mat-label>Logradouro</mat-label>
        <input matInput formControlName="street" />
      </mat-form-field>
    </div>

    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Número</mat-label>
        <input matInput formControlName="number" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Bairro</mat-label>
        <input matInput formControlName="neighborhood" />
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Cidade</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Estado</mat-label>
        <input matInput formControlName="state" />
      </mat-form-field>

      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>País</mat-label>
        <input matInput formControlName="country" />
      </mat-form-field>
    </div>

    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Complemento</mat-label>
        <input matInput formControlName="complement" />
      </mat-form-field>
    </div>

    <div class="flex justify-end">
      <!--      <button-->
      <!--        mat-flat-button-->
      <!--        class="btn-tg w-1/5"-->
      <!--        [disabled]="!checkForm() || loading"-->
      <!--        (click)="addTariff()"-->
      <!--      >-->
      <!--        @if (loading) {-->
      <!--          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>-->
      <!--        } @else {-->
      <!--          @if (edit) {-->
      <!--            Editar-->
      <!--          } @else {-->
      <!--            Adicionar-->
      <!--          }-->
      <!--        }-->
      <!--      </button>-->
    </div>

    <!--  <div class="flex justify-end gap-4 items-center">-->
    <!--    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">-->
    <!--      Cancel-->
    <!--    </button>-->
    <!--    @if (this.editItem.idCreate != undefined) {-->
    <!--      <button-->
    <!--        mat-flat-button-->
    <!--        class="btn-tg w-1/12"-->
    <!--        [disabled]="form.invalid || loading"-->
    <!--        (click)="editAddress()"-->
    <!--      >-->
    <!--        @if (loading) {-->
    <!--          <mat-spinner-->
    <!--            diameter="22"-->
    <!--            class="loading-spinner"-->
    <!--            selected-track-color="red"-->
    <!--          ></mat-spinner>-->
    <!--        } @else {-->
    <!--          Editar-->
    <!--        }-->
    <!--      </button>-->
    <!--    } @else {-->
    <!--      <button-->
    <!--        mat-flat-button-->
    <!--        class="btn-tg w-1/12"-->
    <!--        [disabled]="form.invalid || loading"-->
    <!--        (click)="createAddress()"-->
    <!--      >-->
    <!--        @if (loading) {-->
    <!--          <mat-spinner-->
    <!--            diameter="22"-->
    <!--            class="loading-spinner"-->
    <!--            selected-track-color="red"-->
    <!--          ></mat-spinner>-->
    <!--        } @else {-->
    <!--          Adicionar-->
    <!--        }-->
    <!--      </button>-->
    <!--    }-->
    <!--  </div>-->
  </div>
</mat-card>
